/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metric_Revenue_Switch_To_Native_TokenInputs */



/**
* | output |
* | --- |
* | "Switch On-Chain Revenue to Native Token" |
*
* @param {Metric_Revenue_Switch_To_Native_TokenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const metric_revenue_switch_to_native_token = /** @type {((inputs?: Metric_Revenue_Switch_To_Native_TokenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_Revenue_Switch_To_Native_TokenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Switch On-Chain Revenue to Native Token")
});